import { useRef, useCallback } from 'react';

export function useDebounceFn<T extends (...args: any[]) => void>(
  fn: T,
  delay: number,
): T {
  const timer = useRef<NodeJS.Timeout | null>(null);

  // @ts-ignore
  return useCallback(
    (...args: any[]) => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      timer.current = setTimeout(() => {
        fn(...args);
      }, delay);
    },
    [fn, delay],
  );
}
